module.exports = __webpack_public_path__ + "img/icon_xz1.b44289f8.png";